import React, {Suspense} from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { BrowserRouter } from 'react-router-dom'
import { ErrorFallback } from '../features/common/ErrorFallback'

export function AppProvider({ children }) {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        {/* <BrowserRouter basename="/">{children}</BrowserRouter> */}
        <BrowserRouter basename="/ototo/game2026/hunter/">{children}</BrowserRouter>
      </ErrorBoundary>
    </Suspense>
  )
}
